import { createSlice } from "@reduxjs/toolkit";
import localStorage from "redux-persist/lib/storage";
import { PURGE } from "redux-persist";

const initialState = {
    value:{
        location : '',
        action: '',
        params:{}
    },
    is_loading:false,
    is_modal_customer:false,
    is_modal_transaksi:false,
    is_modal_print:false,
    is_focus:true,
    array_product_to_remove:[],
    is_check_all:false,
}

const actionSlice = createSlice({
    name:'Action',
    initialState,
    reducers:{

        action:(s,a)=>{
            if(a.payload.location) s.value.location = a.payload.location;
            if(a.payload.action)s.value.action = a.payload.action;
            if(a.payload.params)s.value.params = a.payload.params 
        },
        removeAction:(s)=>{
            s.value.action = ''
        },
        setIsLoading:(s,a)=>{
            if(a.payload && !a.payload.status) {s.is_loading = a.payload.status} else
            {s.is_loading = !s.is_loading}
        },
        setOpenModal:(s,a)=>{
            if(a.payload.action == 'open-modal-customer') s.is_modal_customer = !s.is_modal_customer
            if(a.payload.action == 'open-modal-transaksi') s.is_modal_transaksi = !s.is_modal_transaksi
            if(a.payload.action == 'open-modal-print') s.is_modal_print = !s.is_modal_print
            // s.value = a.payload
        },
        setFocus:(s,a)=>{
            s.is_focus = !s.is_focus
        },
        updateArrayProductToRemove:(s,a)=>{
            let index = s.array_product_to_remove.findIndex((item) => item.id == a.payload.id)
           
            if(index == -1) s.array_product_to_remove.push(a.payload)
            else s.array_product_to_remove.splice(index,1)
        },
        emptyArrayProductToRemove:(s)=>{
            s.array_product_to_remove = [];
        },
        setCheckAll:(s,a)=>{
            s.is_check_all = a.payload.check
        },
        purge:(s)=>{
            
        }
    },extraReducers:builder=>{
        builder.addCase(PURGE ,(s) =>{
            s.value = initialState.value
            s.is_loading=false
            s.is_modal_customer=false
            s.array_product_to_remove = [];
        })
    }
})

export const {setCheckAll,action,removeAction,setIsLoading,purge,setOpenModal,setFocus,updateArrayProductToRemove,emptyArrayProductToRemove} = actionSlice.actions
export default actionSlice.reducer